import { ACCENT } from "./constants";

export const buildCalendarStyles = (colors) => ({
  calendarHeaderControl: {
    color: colors.text,
    "&:hover": { backgroundColor: colors.hover },
  },
  calendarHeaderLevel: {
    color: colors.text,
    "&:hover": { backgroundColor: colors.hover },
  },
  weekday: { color: colors.subText },
  monthPickerControl: {
    color: colors.text,
    "&:hover": { backgroundColor: colors.hover },
  },
  yearPickerControl: {
    color: colors.text,
    "&:hover": { backgroundColor: colors.hover },
  },
  monthPickerControlActive: {
    backgroundColor: ACCENT,
    color: "#FFFFFF",
    "&:hover": { backgroundColor: ACCENT },
  },
  yearPickerControlActive: {
    backgroundColor: ACCENT,
    color: "#FFFFFF",
    "&:hover": { backgroundColor: ACCENT },
  },
  day: {
    color: colors.text,
    "&:hover": { backgroundColor: colors.hover },
    "&[data-outside]": { color: colors.subText, opacity: 0.45 },
    "&[data-disabled]": { color: colors.subText, opacity: 0.35 },
    "&[data-weekend]": { color: colors.text },
    // data-in-range MUST come before the teal rules: a start-only selection
    // carries both data-selected and data-in-range, and with equal CSS
    // specificity the last declaration wins — so the teal ones go last.
    "&[data-in-range]": { backgroundColor: colors.inRange, color: colors.text },
    "&[data-selected]": { backgroundColor: ACCENT, color: "#FFFFFF" },
    "&[data-first-in-range]": { backgroundColor: ACCENT, color: "#FFFFFF" },
    "&[data-last-in-range]": { backgroundColor: ACCENT, color: "#FFFFFF" },
  },
});
